export default __webpack_public_path__ + "static/media/group-6449.c2ccb9ef.png";